import {AfterViewInit, Component, DestroyRef, OnInit, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsManager} from 'src/app/services/events.manager';
import {FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ValidateEmail} from 'src/app/validators/form-validator';
import {ContactUsRequestInterface} from 'src/app/interfaces/contact-us-request.interface';
import {PlansService} from 'src/app/services/plans.service';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {PhonePipe} from 'src/app/pipes/phone.pipe';
import {CardItemComponent} from 'src/app/components/card-item/card-item.component';
import {RouterLink} from '@angular/router';
import {NgIf, NgFor} from '@angular/common';
import {HeroComponent} from 'src/app/components/hero/hero.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [HeroComponent, NgIf, NgFor, RouterLink, CardItemComponent, FormsModule, ReactiveFormsModule, PhonePipe]
})

export class HomeComponent implements OnInit, AfterViewInit {
  private _plansService = inject(PlansService);
  private _googleAnalyticsService = inject(GoogleAnalyticsService);
  private _destroyRef = inject(DestroyRef);

  public eventsManager = inject(EventsManager);

  public details: any = {};
  public showDetails: boolean = false;
  public showContactSuccess: boolean = false;
  public showContactError: boolean = false;
  public contactUs: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3)]),
    email: new FormControl('', [Validators.required, ValidateEmail]),
    message: new FormControl('', [Validators.required, Validators.minLength(3)]),
    planName: new FormControl(this.eventsManager.planName),
    planEmail: new FormControl(this.eventsManager.planEmail)
  });
  public info: any = {};

  public ngOnInit(): void {
    this.eventsManager.contactInfoUpdated.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this.info = this.eventsManager.contactInfo;
    });

    this.eventsManager.homePageDetailUpdated.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this.details = this.eventsManager.homePageDetails;
      if (this.eventsManager.homePageDetails !== null) {
        this.showDetails = true;
      }
    });
  }

  public ngAfterViewInit() {
    window.scroll(0, -window.scrollY);
  }

  public sendForm() {
    const request: ContactUsRequestInterface = {name:this.contactUs.get('name')?.value, email:this.contactUs.get('email')?.value, message:this.contactUs.get('message')?.value, planName:this.contactUs.get('planName')?.value, planEmail:this.contactUs.get('planEmail')?.value};
    this._plansService.sendContactUs(request).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this.showContactSuccess = true;
      this._googleAnalyticsService.sendKeyEvent('contact_us_submit', {
        timestamp: new Date().toISOString()
      });
    }, () => {
      this.showContactError = true;
    });
  }

  public findDentist() {
    this._googleAnalyticsService.sendKeyEvent('find_dentist', {
      timestamp: new Date().toISOString()
    });
  }
}
